import React, { useState, useEffect } from "react";
import { fetchMaterialCatalog } from "../utils/MaterialCatalog";

export default function Materials({ width, onDragStart, selectedMaterial, onSelectMaterial }) {
  const [materialsList, setMaterialsList] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const loadMaterials = async () => {
      try {
        const catalog = await fetchMaterialCatalog();
        const categories = Object.keys(catalog);
        console.log('Material categories loaded:', categories);
        setMaterialsList(categories);
      } catch (error) {
        console.error('Error loading materials list:', error);
      } finally {
        setLoading(false);
      }
    };

    loadMaterials();
  }, []);

  return (
    <>
      <aside 
        className="bg-gray-300 dark:bg-gray-800 flex flex-col items-start px-6 py-8 space-y-6 text-lg font-semibold select-none"
        style={{ width: `${width}px` }}
      >
        {loading ? (
          <div className="text-gray-600 dark:text-gray-400">Loading materials...</div>
        ) : (
          materialsList.map((materialName) => (
            <button
              key={materialName}
              onClick={() => onSelectMaterial(materialName)}
              className={`hover:text-gray-700 dark:hover:text-gray-300 text-left w-full break-words ${
                selectedMaterial === materialName ? 'text-gray-900 dark:text-white underline' : 'text-gray-800 dark:text-gray-300'
              }`}
            >
              {materialName}
            </button>
          ))
        )}
      </aside>

      <div
        className="w-1 box-border bg-gray-300 dark:bg-gray-700 hover:bg-gray-400 dark:hover:bg-gray-600 border-r border-gray-400 dark:border-gray-600 cursor-ew-resize transition-colors select-none"
        onMouseDown={onDragStart}
      />
    </>
  );
}
